"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "HeadlineString", {
  enumerable: true,
  get: function () {
    return _headlineString.default;
  }
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _index = _interopRequireDefault(require("../paragraph/index.js"));
var _index2 = _interopRequireDefault(require("../input-bar/index.js"));
var _button = _interopRequireDefault(require("../merch-button/button.js"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _headlineString = _interopRequireDefault(require("./headline-string.js"));
var _index3 = _interopRequireDefault(require("../tag/index.js"));
var _index4 = _interopRequireDefault(require("../actions/index.js"));
var _lazyImage = _interopRequireDefault(require("../image/lazy-image.js"));
var _index5 = _interopRequireDefault(require("../domain-search/index.js"));
var _index6 = _interopRequireDefault(require("../price/index.js"));
var _index7 = _interopRequireDefault(require("../tooltip/index.js"));
var _index8 = _interopRequireWildcard(require("../list/index.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @module HeadlineLockup */
/* eslint-disable complexity */

const reDigit = /\d$/;

/**
 * Make a function to increment header size
 *
 * @param {number} dir - Either 1 (down) or -1 (up)
 * @returns {function(*): string} incrementer
 */
const makeHeadingIncrement = dir => heading => {
  const match = heading.match(reDigit);
  if (!match) return;
  return 'h' + (parseInt(match[0], 10) + dir);
};

/**
 * Increment a header size up
 *
 * @function
 * @param {string} heading - Such as `h2` or `h3`
 * @returns {string} heading
 */
const hUp = makeHeadingIncrement(-1);
const HeadlineContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineContainer",
  class: "core-h17vrswi",
  vars: {
    "h17vrswi-0": [({
      textAlign
    }) => textAlign === 'center' ? textAlign : `flex-${textAlign}`],
    "h17vrswi-1": [({
      textAlign
    }) => textAlign ? textAlign : 'unset'],
    "h17vrswi-3": [({
      textAlign
    }) => textAlign === 'center' ? 'auto' : 'initial']
  }
});
const Description = /*#__PURE__*/(0, _react2.styled)(_index.default)({
  name: "Description",
  class: "core-dicogkn"
});
const HeadlineActionDescription = /*#__PURE__*/(0, _react2.styled)(Description)({
  name: "HeadlineActionDescription",
  class: "core-h106047v"
});
const Disclaimer = /*#__PURE__*/(0, _react2.styled)(_index.default)({
  name: "Disclaimer",
  class: "core-d1lrb1lo"
});
const Ctas = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Ctas",
  class: "core-c3duzvn",
  vars: {
    "c3duzvn-0": [({
      ctaFlexDirection
    }) => ctaFlexDirection ? 'flex' : 'block'],
    "c3duzvn-1": [({
      ctaFlexDirection
    }) => ctaFlexDirection ? ctaFlexDirection : 'column'],
    "c3duzvn-2": [({
      ctaFlexDirection,
      textAlign
    }) => ctaFlexDirection === 'column' ? 'center' : `flex-${textAlign}`],
    "c3duzvn-3": [({
      ctaFlexDirection,
      textAlign
    }) => ctaFlexDirection === 'row' && textAlign === 'center' ? 'center' : `flex-${textAlign}`],
    "c3duzvn-5": [({
      textAlign
    }) => textAlign === 'center' ? 'center' : `flex-${textAlign}`],
    "c3duzvn-6": [({
      ctaFlexDirection
    }) => ctaFlexDirection === 'column' ? 'column' : `row wrap`]
  }
});
const LogoWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "LogoWrapper",
  class: "core-lufbjxj",
  vars: {
    "lufbjxj-0": [({
      height
    }) => `${height}px` || 'auto'],
    "lufbjxj-1": [({
      width
    }) => `${width}px` || 'auto']
  }
});
const Logo = /*#__PURE__*/(0, _react2.styled)(_lazyImage.default)({
  name: "Logo",
  class: "core-lchqvej"
});

/**
 * HeadlineLockup lockup component.
 *
 * @param {Object} props React props
 * @param {string} props.eyebrow Eyebrow text
 * @param {string} props.eyebrowTag Eyebrow element tag
 * @param {Object} props.eyebrowLogo Image Rendering in Eyebrow
 * @param {string|Object} props.heading Header text
 * @param {string} props.description Description text
 * @param {Object} props.descriptionTooltip Tooltip for description
 * @param {Array} props.list List of items to display
 * @param {React.ReactElement} props.ctas Actions component
 * @param {string} props.disclaimer Disclaimer text
 * @param {Object} props.disclaimerTooltip Tooltip for disclaimer
 * @param {string} props.actionDescription Description for actions
 * @param {string} props.tagLabel Text above eyebrow
 * @param {string} props.labelDesign Tag label design
 * @param {String} [props.textAlign='center'] alignment of text
 * @param {String} props.headlineTag headlineTag
 * @param {String} props.headlineSize headlineSize
 * @param {Number} props.headlineLineLength choose a max-width of the lines of copy
 * @param {String} props.ctaFlexDirection choose a max-width of the lines of copy
 * @param {Object} props.priceLockup Price Lockup features
 * @param {String} props.itemPropHeading Used for associating structured data properties with an item for semantic markup purposes
 * @param {String} props.itemPropDescription Description for item properties
 * @returns {React.ReactElement} HeadlineLockup component
 * @public
 */
function HeadlineLockup({
  eyebrow,
  eyebrowTag = 'h2',
  eyebrowLogo = {},
  description,
  descriptionTooltip,
  list,
  actionsLayout,
  ctas,
  actionDescription,
  disclaimer,
  disclaimerTooltip,
  textAlign = 'center',
  heading,
  headlineLineLength = 1.2,
  headlineTag,
  headlineSize,
  headingDataCy,
  tag,
  tagLabel,
  labelDesign,
  labelSize,
  ctaFlexDirection,
  priceLockup,
  descriptionAfterContent,
  style,
  className,
  itemPropHeading,
  itemPropDescription
}) {
  return /*#__PURE__*/_react.default.createElement(HeadlineContainer, {
    "data-cy": "headline",
    textAlign: textAlign,
    className: className,
    style: style
  }, tag // allows for a UXCore tag to be passed in as a react node
  || tagLabel && /*#__PURE__*/_react.default.createElement(_index3.default, {
    className: "headline-tag",
    text: tagLabel,
    design: labelDesign,
    size: labelSize
  }), eyebrow && /*#__PURE__*/_react.default.createElement(_index.default, {
    asType: "title",
    dataCy: "eyebrow",
    text: eyebrow,
    tag: eyebrowTag || headlineTag && hUp(headlineTag) || 'h2',
    className: "headline-eyebrow"
  }), eyebrowLogo?.url && /*#__PURE__*/_react.default.createElement(LogoWrapper, {
    height: eyebrowLogo?.height,
    width: eyebrowLogo?.width,
    className: "headline-eyebrow-logo"
  }, /*#__PURE__*/_react.default.createElement(Logo, (0, _extends2.default)({
    dataCy: "logo",
    loading: eyebrowLogo?.loading === 'eager' ? 'eager' : 'lazy'
  }, eyebrowLogo))), heading && /*#__PURE__*/_react.default.createElement(_headlineString.default, {
    heading: heading,
    headlineTag: headlineTag,
    headlineSize: headlineSize,
    headlineLineLength: headlineLineLength,
    headingDataCy: headingDataCy,
    itemProp: itemPropHeading
  }), description && /*#__PURE__*/_react.default.createElement(Description, {
    asType: "paragraph",
    size: 1,
    dataCy: "description",
    text: description,
    tooltip: descriptionTooltip,
    className: "headline-description",
    style: headlineLineLength ? {
      maxWidth: `${headlineLineLength * 25}em`
    } : {},
    "data-after-content": descriptionAfterContent,
    itemProp: itemPropDescription
  }), list && /*#__PURE__*/_react.default.createElement(_index8.default, {
    layout: "headline-list",
    items: list,
    textAlign: textAlign,
    iconColor: `${_intents.default.ux.box.foregroundColor}`
  }), priceLockup && /*#__PURE__*/_react.default.createElement(_index6.default, (0, _extends2.default)({
    align: textAlign
  }, priceLockup)), ctas && /*#__PURE__*/_react.default.createElement(Ctas, {
    "data-cy": "ctas",
    className: "headline-ctas",
    ctaFlexDirection: ctaFlexDirection ?? 'row',
    textAlign: textAlign
  }, Array.isArray(ctas) ? /*#__PURE__*/_react.default.createElement(_index4.default, {
    actionsLayout: actionsLayout,
    ctas: ctas
  }) : ctas), actionDescription && /*#__PURE__*/_react.default.createElement(HeadlineActionDescription, {
    asType: "paragraph",
    size: 0,
    dataCy: "action-description",
    className: "headline-action-description",
    text: actionDescription,
    style: headlineLineLength ? {
      maxWidth: `${headlineLineLength * 25}em`
    } : {}
  }), disclaimer && /*#__PURE__*/_react.default.createElement(Disclaimer, {
    asType: "paragraph",
    size: -2,
    dataCy: "disclaimer",
    text: disclaimer,
    tooltip: disclaimerTooltip,
    style: headlineLineLength ? {
      maxWidth: `${headlineLineLength * 25}em`
    } : {},
    className: "headline-disclaimer"
  }));
}
HeadlineLockup.propTypes = {
  eyebrow: _propTypes.default.string,
  eyebrowTag: _propTypes.default.oneOf(['h1', 'h2', 'h3', 'p']),
  eyebrowLogo: _propTypes.default.object,
  heading: _propTypes.default.node,
  headlineSize: _propTypes.default.oneOf(['d1', 'd2', 'd3', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  headlineTag: _propTypes.default.oneOf(['h1', 'h2', 'h3', 'h4', 'p']),
  description: _propTypes.default.node,
  descriptionTooltip: _propTypes.default.shape(_index7.default.propTypes),
  list: _propTypes.default.arrayOf(_propTypes.default.shape(_index8.ListItem.propTypes)),
  actionsLayout: _propTypes.default.oneOf(['button-set', 'input-bar', 'domain-search', 'none']),
  ctas: _propTypes.default.oneOfType([_propTypes.default.instanceOf(_index4.default), _propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.shape(_button.default.propTypes), _propTypes.default.shape(_index2.default.propTypes), _propTypes.default.shape(_index5.default.propTypes)]))]),
  ctaFlexDirection: _propTypes.default.oneOf(['row', 'column']),
  actionDescription: _propTypes.default.node,
  disclaimer: _propTypes.default.string,
  disclaimerTooltip: _propTypes.default.shape(_index7.default.propTypes),
  textAlign: _propTypes.default.oneOf(['start', 'center', 'end']),
  headlineLineLength: _propTypes.default.number,
  tag: _propTypes.default.node,
  tagLabel: _propTypes.default.string,
  labelDesign: _propTypes.default.string,
  labelSize: _propTypes.default.string,
  ..._headlineString.default.propTypes,
  priceLockup: _propTypes.default.object,
  style: _propTypes.default.object,
  itemPropHeading: _propTypes.default.string,
  itemPropDescription: _propTypes.default.string
};
var _default = exports.default = HeadlineLockup;